import { styled } from 'next-yak'

import * as colors from '../../constants/colors'
import * as copy from '../copy'

export type ImageProps = {
  sizing?: 'contain' | 'cover'
}

export const Content = styled.div`
  max-width: 624px;
  padding: 0px 0px 0px 15px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const Image = styled.img<ImageProps>`
  object-fit: ${({ sizing = 'cover' }) => sizing};
  object-position: center;
  width: 100%;
  height: 100%;

  // HACK: IE: hide image, object-fit not supported
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    opacity: 0;
  }
`
export const SquarePicture = styled(Image)`
  border-radius: 10px;
  height: 120px;
  min-width: 120px;
  width: 120px;
`

export const Title = styled(copy.M.semiBold)`
  color: ${colors.PRIMARY_GREY_900};
`

export const Subtitle = styled(copy.S.semiBold)`
  color: ${colors.TEXT_TERTIARY};
  flex-basis: 100%;
`

export const Price = styled(copy.M.semiBold)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-self: flex-end;
`

export const DiscountedPrice = styled(copy.S.regular)`
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  width: 100%;
  text-decoration: line-through;
  color: ${colors.PRIMARY_GREY_500};
`

export const QuantityWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;
  padding-top: 16px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 584px;
  padding-bottom: 30px;
`
